@if (iframeSrc()) {
<div class="challenge-modal" [style.width.px]="500">
  <iframe
    [src]="iframeSrc()"
    style="width: 100%; height: 900px; border: none"
  ></iframe>
</div>
} @else {
<div class="ac-ctr ac-flex">
  <ac-loading type="spinner" [size]="32" />
</div>
}
